<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ReturnToSellBubble from './components/ReturnToSellBubble.vue';
import { platformReturnUrl } from './services/platform-return';

const route = useRoute();
const isAdmin = computed(() => route.path.startsWith('/admin'));
const sellReturnUrl = computed(() => {
  route.fullPath;
  return platformReturnUrl();
});
</script>

<template>
  <main :class="isAdmin ? 'admin-root' : 'mobile-stage'">
    <RouterView />
    <ReturnToSellBubble v-if="!isAdmin && sellReturnUrl" :url="sellReturnUrl" />
  </main>
</template>
